<template>
  <div>
    <!-- summary section -->
    <section class="pdf-item bg-primary-300 w-full p-4 rounded-lg">
      <SimpleTable
        class="mt-2"
        :title="title"
        :headers="commonSummaryHeader()"
        :items="commonSummaryData()"
        :options="summaryOptions"
      />
    </section>
    <!-- summary section -->
    <!-- Details section -->
    <section
      class="item-summary bg-white my-4 p-4 border rounded-lg w-full bg-gray-50"
      v-if="false"
      v-for="(item, index) in tableDataHistory"
    >
      <AnyChart
        class="justify-self-stretch border rounded-lg mb-4 ..."
        :title="index"
        :reportData="getChartData(item[0].formulaGroup)"
        :unit="getUnit(item[0].formulaGroup)"
        :printable="printable"
        :period="reportData.form.dataForm"
        @rawChart="setChartBaseSource($event, index)"
      />
      <HistoricalReport
        :title="`${index} Details `"
        :items="item"
        :assets="assets"
        :unit="getUnit(item[0].formulaGroup)"
        :type="reportData.form.dataForm"
        :printable="printable"
      />
    </section>
    <!-- Details section -->
  </div>
</template>
<script>
import HistoricalReport from '@/components/Reports/HistoricalReport'
import SimpleTable from '@/components/dx/SimpleTable'
import AnyChart from '@/components/Reports/AnyChart'
import PdfReportTemplate from '@/components/Reports/PdfReport'
import reportContentMixin from '@/mixins/ReportContent'

export default {
  mixins: [reportContentMixin],
  props: {
    title: {
      type: String
    },
    period: {
      type: String
    },
    exportPdf: {
      type: Boolean
    }
  },
  components: {
    HistoricalReport,
    SimpleTable,
    AnyChart
  },
  data() {
    return {
      grouppedAssets: [],
      assets: [],
      assetsProperties: [],
      grouppedData: {},
      summaryOptions: {
        allowToAdd: false,
        allowToRefetch: false,
        allowExporting: true,
        autoWidth: false
      }
    }
  },
  async mounted() {
    // await this.historicalData()
  },
  methods: {
    commonSummaryData() {
      var bodyData = []

      // get sensor data

      this.reportData.report.ListRack.map((data, index) => {
        let content = {}
        content['Id'] = index
        content['Rack'] = data.DetailITALocation.Rack
        content['Customer'] = data.CompanyName
        content['Peak'] = data.DetailSensorDCEPower.PeakStr
        content['Average'] = data.DetailSensorDCEPower.AverageStr
        content['Min'] = data.DetailSensorDCEPower.MinimumStr
        content['Unit'] = data.DetailSensorDCEPower.UnitStr
        content['Peak Time'] =
          data.DetailSensorDCEPower.PeakTimeStr !== 'N/A'
            ? this.formattedDateTime(data.DetailSensorDCEPower.PeakTimeStr)
            : data.DetailSensorDCEPower.PeakTimeStr
        content['Min Time'] =
          data.DetailSensorDCEPower.MinimumTimeStr !== 'N/A'
            ? this.formattedDateTime(data.DetailSensorDCEPower.MinimumTimeStr)
            : data.DetailSensorDCEPower.MinimumTimeStr

        bodyData.push(content)
      })

      return bodyData
    },
    commonSummaryHeader() {
      return [
        {
          type: 'string',
          text: 'Rack',
          value: 'Rack'
        },
        {
          type: 'string',
          text: 'Customer',
          value: 'Customer'
        },
        {
          type: 'string',
          text: 'Peak',
          value: 'Peak'
        },
        {
          type: 'string',
          text: 'Average',
          value: 'Average'
        },
        {
          type: 'string',
          text: 'Min',
          value: 'Min'
        },
        {
          type: 'string',
          text: 'Unit',
          value: 'Unit'
        },
        {
          type: 'string',
          text: 'Peak Time',
          value: 'Peak Time'
        },
        {
          type: 'string',
          text: 'Min Time',
          value: 'Min Time'
        }
      ]
    },
    preparePdf() {
      try {
        var _this = this

        PdfReportTemplate.clear()
        // set pdf title
        PdfReportTemplate.setTitle(
          `${this.period} ${this.reportData.form.reportType}`
        )
        // cover page
        PdfReportTemplate.addCover(_this.customerLogo)
        for (var header of this.reportHeader) {
          PdfReportTemplate.append({
            columns: [
              {
                // auto-sized columns have their widths based on their content
                width: 80,
                style: ['coverTitle'],
                text: header.name,
                alignment: 'left'
              },
              {
                width: '*',
                text: `: ${header.content}`,
                style: ['coverTitleVal'],
                alignment: 'left'
              }
            ],
            margin: [0, 10]
          })
        }

        // toc page
        PdfReportTemplate.newPage()
        PdfReportTemplate.addTOC()

        // set landscape layout
        PdfReportTemplate.setOrientation('landscape')

        // remapping summary data
        var commonSummaryData = JSON.parse(
          JSON.stringify(_this.commonSummaryData())
        ).map(function (x) {
          for (var property in x) {
            var skippedProperties = ['Asset Id', 'Id', 'Location']

            if (!skippedProperties.includes(property)) {
              x[property] = {
                text: x[property],
                alignment: 'right'
              }
            }
          }

          return x
        })
        // summary
        PdfReportTemplate.addHeader('Summary Data')
        PdfReportTemplate.append(
          PdfReportTemplate.tableObject(
            commonSummaryData,
            _this.commonSummaryHeader()
          )
        )

        // report content
        Object.keys(this.tableDataHistory).forEach(function (index) {
          // new page
          PdfReportTemplate.newPage()

          // header
          PdfReportTemplate.addHeader(index)

          // getting chart image
          var chartImage = _this.chartImage.find((x) => x.name === index)
          // remapping historical data
          var historicalBody = JSON.parse(
            JSON.stringify(_this.tableDataHistory[index])
          ).map(function (x) {
            for (var property in x) {
              x[property] = {
                text: x[property],
                alignment: 'right'
              }
            }

            // set date
            x.Date = _this.readableFormattedDate(x.date.text)
            x[_this.dateColumnLabel()] = x.Date

            return x
          })

          var key = 0
          // separate table columns every 10 columns
          for (var splittedColumn of _this.splitArray(_this.assets, 10)) {
            if (_this.assets.length > 10) {
              PdfReportTemplate.addSubHeader(
                `Details of (${splittedColumn[0]} - ${
                  splittedColumn[splittedColumn.length - 1]
                })`
              )
            }

            // appending chart image
            if (chartImage && chartImage.source[key]) {
              PdfReportTemplate.append({
                image: chartImage ? chartImage.source[key] : '',
                width: 650,
                margin: [0, 0, 0, 10],
                alignment: 'center'
              })
            }

            // table details
            PdfReportTemplate.append(
              PdfReportTemplate.table(
                historicalBody,
                [_this.dateColumnLabel()].concat(splittedColumn)
              )
            )

            if (_this.assets.length > 10) {
              PdfReportTemplate.newPage()
            }
            // incrementing key
            key++
          }
        })

        this.$emit('pdfSource', {
          filename: this.getGeneratedFileName(),
          source: PdfReportTemplate.template
        })
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
